export default "__VITE_ASSET__CAddYRH3__"